export default function emitGuestPickerEvent(eventaction, options = {}) {
    // If edap does not exist, define array so overloaded push() method can raise event
    window.edap = window.edap || [];
    window.edap.push((edap) => {
        edap.trigger(eventaction, options);
    });
}

export const getStringFromNumber = (value) => {
    if (typeof value !== 'number') {
        return value;
    }
    return value.toString();
};

export const eventGuestUpdateSubmitted = ({actionLocation, adultsCount, childrenCount, bedroomsCount, petIncluded}) => {
    emitGuestPickerEvent('guest_update.submitted', {
        action_location: actionLocation,
        adult_count: getStringFromNumber(adultsCount),
        child_count: getStringFromNumber(childrenCount),
        bedroom_count: getStringFromNumber(bedroomsCount),
        with_pets: `${petIncluded}`
    });
};
